import React from "react";
import YouTube from "react-youtube";

import styles from "./YouTubeChannel.module.scss";
import YouTubeChannelButton from "./YouTubeChannelButton";

type Props = {
  youtube_url: string;
  youtube_data: Array<string>;
};

export const YouTubeChannel: React.FC<Props> = (props) => {
  const { youtube_url, youtube_data } = props;

  return (
    <div className={styles["youtube-channel"]}>
      <h3 className={styles["youtube-channel__title"]}>YouTubeチャンネル</h3>
      {youtube_data.length > 0 ? (
        <div
          className={styles["youtube-channel__content"]}
          data-testid="youtube"
        >
          <ul className={styles["youtube-channel__content-slider"]}>
            {youtube_data.map((value, index) => {
              return (
                <li key={index}>
                  <YouTube
                    videoId={value}
                    id={`player${index}`}
                    opts={{
                      width: "100%",
                      height: "100%",
                    }}
                    onReady={(e: any) => {
                      e.target.setVolume(20);
                    }}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}
      <YouTubeChannelButton link={youtube_url?.toString()} />
    </div>
  );
};

export default YouTubeChannel;
